import { GraphqlQueryResponse } from "@/Common/api/types/GraphqlQueryResponse";
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";
import { IMappedPosition } from "@Common/types/positions/api";

type TApplyMappedPositions = {
	data: {
		data: {
			getUsersFromEmployees: boolean;
		};
	};
};
export async function applyMappedPositions(locationId: string) {
	const query = gql`
		query getUsersFromEmployees($locationId: String!) {
			getUsersFromEmployees(locationId: $locationId)
		}
	`;
	const variables = {
		locationId,
	};

	try {
		const response: TApplyMappedPositions = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUsersFromEmployees;
	} catch (err) {
		errorLogger(err as Error, { function: "applyMappedPositions", message: "Failed to apply mapped positions", variables });
		return null;
	}
}

export async function getPositionsMapping(locationId: string) {
	const query = gql`
		query getPositionsMapping($locationId: String!) {
			getPositionsMapping(locationId: $locationId) {
				managedPositions {
					_id
					systemPosition
					payrollPosition
					isDepartmental
				}
				accountingPositions {
					systemPosition
					payrollPosition
				}
				requiredPositions {
					_id
					systemPosition
					payrollPosition
				}
				availablePositions {
					key
					label
				}
			}
		}
	`;

	const variables = {
		locationId,
	};

	try {
		const response: GraphqlQueryResponse<
			"getPositionsMapping",
			{
				managedPositions: IMappedPosition[];
				accountingPositions: IMappedPosition[];
				requiredPositions: IMappedPosition[];
				availablePositions: { key: string; label: string }[];
			}
		> = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getPositionsMapping;
	} catch (err) {
		errorLogger(err as Error, { function: "getPositionsMapping", message: "Failed to get positions mapping", variables });
		return null;
	}
}
